import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Autocomplete,
  Snackbar,
  Alert,
  Stack,
  Chip,
  Paper,
  Fab,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { socket } from "../../socket";

import { useNavigate } from "react-router-dom";
import { useTheme, alpha } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import dayjs from "dayjs";

import AddTareas from "./AddTareas";
// Chat tareas
import TareaChat from "./TareaChat";

import {
  getAllTareas,
  getTareasDefinicion,
  getDisenos,
  getMuestras,
  getMateriales,
  updateTarea,
  getMensajesNoLeidos,
  getTareasMensajesCount,
  deleteTarea,
  getTareasParticipantes,
  postTareasParticipante,
  deleteTareasParticipante,
} from "../../api/Proyectos/ProyectosTareasApi";
import { getAllProyectos } from "../../api/Proyectos/proyectoApi";
import { getAllUsers, getUserById } from "../../api/User/userApi";
import { jwtDecode } from "jwt-decode";
import { SidebarContext } from "../Sidebar/SidebarProvider";
import { TareasVistasApi } from "../../api/TareasVistas/TareasVistasApi";

import { getDocumentosByTarea } from "../../api/Tareas/documentosTareasApi";
import DocumentosTareas from "../Proyectos/DocumentosTareas";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Add } from "@mui/icons-material";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import {
  pageFieldSx,
  pageHeroShellSx,
  pageMobileCardSx,
  pageContentCardSx,
  pageSectionTitleSx,
  pagePrimaryButtonSx,
} from "../../styles/pageModernStyles";

// ðŸŽ¨ Colores fijos por definiciÃ³n
const definicionColors = {
  "Enviar proto": "#42a5f5",
  "Revisar fitting": "#ab47bc",
  "Subir muestras a portal": "#26a69a",
  "Hacer escandallo": "#ffa726",
  "Aprobar color": "#ef5350",
  "Enviar al cliente": "#66bb6a",
};

/** Excluye Admin del select de responsable / participantes. */
const isSelectableUser = (u) => {
  if (!u) return false;
  if (u.isAdmin) return false;
  const name = String(u.username || "").trim().toLowerCase();
  return name !== "admin";
};

const ROW_HEIGHT = 52;
const GANTT_HEADER_HEIGHT = 48;
const GANTT_PX_PER_DAY = 40;

// ðŸ”¹ Dibuja las barras y bolitas
const PointsChart = ({ xAxisMap, yAxisMap, data }) => {
  const xAxis = Object.values(xAxisMap ?? {})[0];
  const yAxis = Object.values(yAxisMap ?? {})[0];
  if (!xAxis?.scale || !yAxis?.scale) return null;

  const xScale = xAxis.scale;
  const yScale = yAxis.scale;
  const bandwidth = yScale.bandwidth ? yScale.bandwidth() : 50;

  return (
    <g>
      {data.map((d, i) => {
        const xStart = xScale(new Date(d.inicio).getTime());
        const xEnd = xScale(new Date(d.fin).getTime());
        const y = yScale(d.tarea) + bandwidth / 1.7;
        if (!xStart || !xEnd || isNaN(xStart) || isNaN(xEnd) || !y) return null;

        const color =
          d.estado === "Done"
            ? "#4caf50"
            : d.estado === "Running"
              ? "#2196f3"
              : "#fbc02d";

        return (
          <g key={i}>
            <line
              x1={xStart}
              x2={xEnd}
              y1={y}
              y2={y}
              stroke={color}
              strokeWidth="6"
              strokeLinecap="round"
              opacity="0.6"
            />
            <circle
              cx={xEnd}
              cy={y}
              r={6}
              fill={color}
              stroke="#333"
              strokeWidth={1}
            />
          </g>
        );
      })}
    </g>
  );
};

const ToDoListGlobal = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const showSplitView = useMediaQuery(theme.breakpoints.up("lg"));
  const accent = theme.palette.primary.main;
  const navigate = useNavigate();
  const { contentMargin } = useContext(SidebarContext);

  const { t } = useTranslation();
  const [panelView, setPanelView] = useState("list");

  // Estados base
  const [rows, setRows] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const chartRef = useRef(null);
  const exportRef = useRef(null);

  // Estados de control
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(true);

  // Estado del diÃ¡logo de ediciÃ³n
  const [openEstadoDialog, setOpenEstadoDialog] = useState(false);
  const [tareaSeleccionada, setTareaSeleccionada] = useState(null);
  const [nuevoEstado, setNuevoEstado] = useState("");
  const [nuevaFechaInicio, setNuevaFechaInicio] = useState("");
  const [nuevaFechaFin, setNuevaFechaFin] = useState("");

  //Documentos
  const [openDocsDialog, setOpenDocsDialog] = useState(false);
  const [tareaDocs, setTareaDocs] = useState(null);

  // ðŸ“Š Estado y lÃ³gica de ordenaciÃ³n
  const [sortModel, setSortModel] = useState({ field: "id", sort: "asc" });

  // AÃ±adir Tareas
  const [openAddDialog, setOpenAddDialog] = useState(false);

  // ðŸ’¬ Chat lateral
  const [openChat, setOpenChat] = useState(false);
  const [selectedTarea, setSelectedTarea] = useState(null);

  // Ver los Done
  const [showDone, setShowDone] = useState("ongoing"); // valor por defecto

  // Estado de la imagen en hover
  const [hoveredImage, setHoveredImage] = useState(null);
  const [hoverPos, setHoverPos] = useState({ x: 0, y: 0 });

  // alertas cuando eliminamos o actualizamos
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const refreshDocsCount = async (tareaId) => {
    try {
      const docs = await getDocumentosByTarea(tareaId);
      const API = process.env.REACT_APP_API_URL;

      const firstImage = docs.find((d) =>
        /\.(png|jpe?g|gif|webp)$/i.test(d.Archivo),
      );
      const thumbnailUrl = firstImage
        ? `${API}/uploads/tareas/${firstImage.Archivo}`
        : null;

      setRows((prev) =>
        prev.map((t) =>
          t.id === tareaId
            ? { ...t, documentos: docs.length, thumbnail: thumbnailUrl }
            : t,
        ),
      );
    } catch (err) {
      console.error("âŒ Error refrescando documentos:", err);
    }
  };

  const load = async () => {
    setIsLoading(true);
    setHasAccess(true);

    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    let userId = null;
    let username = "";
    let isAdmin = false;
    let hasPermission = false;

    try {
      const decoded = jwtDecode(token);
      userId = decoded.userId || decoded.id;
      username = String(decoded.username || "").trim();
    } catch (err) {
      console.error("âŒ Error decoding token:", err);
      setIsLoading(false);
      return;
    }

    // Obtener permisos
    let userPermissions = {};
    try {
      if (userId) {
        const user = await getUserById(userId);
        userPermissions = user || {};
      }
    } catch (error) {
      console.error("âŒ Error fetching user permissions:", error);
    }

    hasPermission = Boolean(userPermissions.Permiso_ToDoListGlobal);
    isAdmin = Boolean(userPermissions.isAdmin);

    if (!hasPermission && !isAdmin) {
      setHasAccess(false);
      setIsLoading(false);
      return;
    }

    try {
      const [
        tareas,
        proyectos,
        usuarios,
        definiciones,
        disenosData,
        muestrasData,
        materialesData,
      ] = await Promise.all([
        getAllTareas(showDone),
        getAllProyectos(),
        getAllUsers(),
        getTareasDefinicion(),
        getDisenos(),
        getMuestras(),
        getMateriales(),
      ]);

      // ðŸ”‘ MAPS POR ID (CLAVE DEL CAMBIO)
      const usuariosMap = usuarios.reduce((acc, u) => {
        acc[u.id] = u;
        return acc;
      }, {});

      const proyectosMap = proyectos.reduce((acc, p) => {
        acc[p.id] = p.subject || `Proyecto ${p.id}`;
        return acc;
      }, {});

      const definicionesMap = definiciones.reduce((acc, d) => {
        acc[d.Id] = d.Nombre;
        return acc;
      }, {});

      const disenosMap = disenosData.reduce((acc, d) => {
        acc[d.id] = d;
        return acc;
      }, {});

      const muestrasMap = muestrasData.reduce((acc, m) => {
        acc[m.ID_MUESTRA] = m;
        return acc;
      }, {});

      const materialesMap = materialesData.reduce((acc, m) => {
        acc[m.Id] = m;
        return acc;
      }, {});

      let tareasFiltradas = [];
      if (isAdmin) {
        tareasFiltradas = tareas;
      } else if (hasPermission) {
        const uname = username.toLowerCase();
        tareasFiltradas = tareas.filter((t) => {
          if (Number(t.ResponsableId) === Number(userId)) return true;
          const owner = String(t.ClienteOwner || "").trim().toLowerCase();
          if (Boolean(uname) && owner === uname) return true;
          const participanteIds = Array.isArray(t.ParticipanteIds)
            ? t.ParticipanteIds
            : [];
          return participanteIds.some(
            (pid) => Number(pid) === Number(userId),
          );
        });
      }

      // Marcar vistas
      try {
        const tareaIds = tareasFiltradas.map((t) => t.Id);
        if (tareaIds.length > 0) {
          await TareasVistasApi.marcarVistasEnLote(tareaIds);
          window.dispatchEvent(new Event("tareas-vistas-clear"));
        }
      } catch (err) {
        console.error("âŒ Error marcando tareas vistas:", err);
      }

      // ðŸ§© MAPEO SIN .find()
      const mapped = tareasFiltradas.map((t) => {
        let relacionNombre = "";

        if (t.RelacionTipo === "DiseÃ±o") {
          relacionNombre =
            disenosMap[t.RelacionId]?.nombre || `DiseÃ±o ID ${t.RelacionId}`;
        } else if (t.RelacionTipo === "Muestra") {
          relacionNombre =
            muestrasMap[t.RelacionId]?.MUESTRA || `Muestra ID ${t.RelacionId}`;
        } else if (t.RelacionTipo === "Material") {
          relacionNombre =
            materialesMap[t.RelacionId]?.NombreMaterial ||
            `Material ID ${t.RelacionId}`;
        }

        return {
          id: t.Id,
          tarea: t.Descripcion || `Tarea ${t.Id}`,
          definicion: definicionesMap[t.TituloId] || "",
          estado: t.Estado,
          fin: t.FechaLimite,
          inicio: t.FechaCreacion,
          proyecto: proyectosMap[t.ProyectoId] || "â€”",
          responsable: usuariosMap[t.ResponsableId] || {},
          creador: usuariosMap[t.CreadorId] || {},
          relacionTipo: t.RelacionTipo,
          relacionNombre,
        };
      });

      // ðŸ—‚ï¸ Documentos
      const API = process.env.REACT_APP_API_URL;
      const docInfo = {};

      const docsResults = await Promise.all(
        tareasFiltradas.map((t) =>
          getDocumentosByTarea(t.Id)
            .then((docs) => ({ tareaId: t.Id, docs }))
            .catch(() => ({ tareaId: t.Id, docs: [] })),
        ),
      );

      docsResults.forEach(({ tareaId, docs }) => {
        const firstImage = docs.find((d) =>
          /\.(png|jpe?g|gif|webp)$/i.test(d.Archivo),
        );

        docInfo[tareaId] = {
          count: docs.length,
          thumbnail: firstImage
            ? `${API}/uploads/tareas/${firstImage.Archivo}`
            : null,
        };
      });

      // ðŸ’¬ Mensajes
      const noLeidosMap = {};
      const noLeidosResults = await Promise.all(
        tareasFiltradas.map((t) =>
          getMensajesNoLeidos(t.Id, userId)
            .then(({ noLeidos }) => ({ tareaId: t.Id, noLeidos }))
            .catch(() => ({ tareaId: t.Id, noLeidos: 0 })),
        ),
      );

      noLeidosResults.forEach(({ tareaId, noLeidos }) => {
        noLeidosMap[tareaId] = noLeidos;
      });

      const totalMsgsMap = {};
      const totalMsgsResults = await Promise.all(
        tareasFiltradas.map((t) =>
          getTareasMensajesCount(t.Id)
            .then((count) => ({ tareaId: t.Id, count }))
            .catch(() => ({ tareaId: t.Id, count: 0 })),
        ),
      );

      totalMsgsResults.forEach(({ tareaId, count }) => {
        totalMsgsMap[tareaId] = count;
      });

      // ðŸ§© Merge final
      const mappedWithDocs = mapped.map((t) => ({
        ...t,
        documentos: docInfo[t.id]?.count || 0,
        thumbnail: docInfo[t.id]?.thumbnail || null,
        noLeidos: noLeidosMap[t.id] || 0,
        hasMessages: (totalMsgsMap[t.id] ?? 0) > 0,
      }));

      setRows(mappedWithDocs);
      setChartData(mappedWithDocs.filter((r) => r.fin));
    } catch (error) {
      console.error("âŒ Error cargando tareas:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // âœ… Validar token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
    else {
      try {
        const decodedToken = jwtDecode(token);
        if (decodedToken.exp < Date.now() / 1000) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } catch {
        navigate("/login");
      }
    }
  }, [navigate]);

  // âœ… Cargar datos
  useEffect(() => {
    load();
  }, [showDone]);

  // Eliminar globalmente con socket
  useEffect(() => {
    const handleTareaEliminada = ({ tareaId, deletedBy }) => {
      setRows((prev) => prev.filter((t) => t.id !== tareaId));
      setChartData((prev) => prev.filter((t) => t.id !== tareaId));

      // ðŸŽ¯ Mostrar aviso visual
      setSnackbar({
        open: true,
        message: deletedBy
          ? `Task deleted by ${deletedBy}`
          : `A task was deleted by another user`,
        severity: "warning",
      });
    };

    socket.on("tarea-eliminada", handleTareaEliminada);

    return () => socket.off("tarea-eliminada", handleTareaEliminada);
  }, []);

  // Sincronizar scroll vertical tabla â†” grÃ¡fico
  useEffect(() => {
    const tableScroll = document.getElementById("todo-table-scroll");
    const chartBody = document.getElementById("todo-chart-body");
    if (!tableScroll || !chartBody) return;

    const syncScroll = (e) => {
      if (e.target === tableScroll) chartBody.scrollTop = tableScroll.scrollTop;
      else tableScroll.scrollTop = chartBody.scrollTop;
    };

    tableScroll.addEventListener("scroll", syncScroll);
    chartBody.addEventListener("scroll", syncScroll);

    return () => {
      tableScroll.removeEventListener("scroll", syncScroll);
      chartBody.removeEventListener("scroll", syncScroll);
    };
  }, [rows.length, showDone, filterText]);

  // Mensajes leÃ­dos
  useEffect(() => {
    const handleMensajesLeidos = (e) => {
      const tareaId = e.detail.tareaId;
      setRows((prev) =>
        prev.map((t) => (t.id === tareaId ? { ...t, noLeidos: 0 } : t)),
      );
    };

    window.addEventListener("tareas-mensajes-leidos", handleMensajesLeidos);
    return () =>
      window.removeEventListener(
        "tareas-mensajes-leidos",
        handleMensajesLeidos,
      );
  }, []);

  useEffect(() => {
    socket.on("tareas-documento-actualizado", async ({ tareaId }) => {
      try {
        const docs = await getDocumentosByTarea(tareaId);
        setRows((prev) =>
          prev.map((t) =>
            t.id === tareaId ? { ...t, documentos: docs.length } : t,
          ),
        );
      } catch (err) {
        console.error("âŒ Error actualizando documentos vÃ­a socket:", err);
      }
    });

    return () => socket.off("tareas-documento-actualizado");
  }, []);

  useEffect(() => {
    socket.on("tareas-mensajes-leidos", ({ tareaId }) => {
      setRows((prev) =>
        prev.map((t) => (t.id === tareaId ? { ...t, noLeidos: 0 } : t)),
      );
    });
    return () => socket.off("tareas-mensajes-leidos");
  }, []);

  // ðŸ“© Escuchar nuevos mensajes para actualizar las bolitas
  useEffect(() => {
    const handleNuevoMensaje = ({ tareaId, mensaje }) => {
      // Incrementar el contador de no leÃ­dos solo si el chat NO estÃ¡ abierto
      setRows((prev) =>
        prev.map((t) =>
          t.id === tareaId
            ? {
                ...t,
                noLeidos:
                  openChat && selectedTarea?.id === tareaId
                    ? 0 // si estÃ¡ abierto, ya se marcarÃ¡ como leÃ­do
                    : (t.noLeidos || 0) + 1,
                hasMessages: true, // asegura que haya azul cuando se lean
              }
            : t,
        ),
      );
    };

    socket.on("tareas-nuevo-mensaje", handleNuevoMensaje);

    return () => socket.off("tareas-nuevo-mensaje", handleNuevoMensaje);
  }, [openChat, selectedTarea]);

  // enseÃ±ar los Done
  /*   useEffect(() => {
    load();
  }, [showDone]); */

  // ðŸ”Ž Filtro
  const filteredRows = rows.filter((r) => {
    const values = [
      r.tarea,
      r.definicion,
      r.proyecto,
      r.responsable,
      r.responsable.username,
      r.creador.CreadorId,
      r.creador.username,
      r.estado,
      r.relacionNombre,
    ]
      .join(" ")
      .toLowerCase();

    const matchText = values.includes(filterText);
    const matchStatus =
      showDone === "all"
        ? true
        : showDone === "ongoing"
          ? r.estado !== "Done"
          : r.estado === "Done";

    return matchText && matchStatus;
  });

  // ðŸŸ¥ Centrar el scroll horizontal en la lÃ­nea de HOY al cargar
  const fechasRef = useRef({ startMin: null, endMax: null });

  // Actualiza las fechas en el ref una vez calculadas
  useEffect(() => {
    if (!chartData?.length) return;

    const filteredChartData = chartData.filter((r) => r.fin);
    if (!filteredChartData.length) return;

    const startMin = Math.min(
      ...filteredChartData.map((d) => new Date(d.inicio).getTime()),
    );
    const endMax = Math.max(
      ...filteredChartData.map((d) => new Date(d.fin).getTime()),
    );

    fechasRef.current = { startMin, endMax };
  }, [chartData]);

  // Usa el ref para centrar el scroll cuando cambie chartData
  useEffect(() => {
    const chartBody = document.getElementById("todo-chart-body");
    const { startMin, endMax } = fechasRef.current;

    if (!chartBody || !startMin || !endMax) return;

    const today = Date.now();
    const totalWidth =
      ((endMax - startMin) / (1000 * 60 * 60 * 24)) * GANTT_PX_PER_DAY;

    let scrollLeft = 0;
    if (today >= startMin && today <= endMax) {
      const xToday = ((today - startMin) / (endMax - startMin)) * totalWidth;
      scrollLeft = Math.max(xToday - chartBody.clientWidth / 2, 0);
    } else if (today > endMax) {
      scrollLeft = Math.max(totalWidth - chartBody.clientWidth, 0);
    }

    const timer = window.setTimeout(() => {
      chartBody.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }, 120);

    return () => window.clearTimeout(timer);
  }, [chartData, rows.length, filterText, showDone]);

  const sortedRows = React.useMemo(() => {
    const sorted = [...filteredRows];
    if (!sortModel?.field) return sorted;

    sorted.sort((a, b) => {
      const aVal = a[sortModel.field];
      const bVal = b[sortModel.field];

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (aVal < bVal) return sortModel.sort === "asc" ? -1 : 1;
      if (aVal > bVal) return sortModel.sort === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [filteredRows, sortModel]);

  // ðŸŒ€ Estado de carga
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  // ðŸš« Sin permisos o sin tareas
  if (!hasAccess || !rows.length) {
    return (
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "gray",
          ...contentMargin,
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>
          ðŸ–{t("ToDoList.notaskAssigned")}
        </Typography>
        <Typography variant="body2">{t("ToDoList.notaskpermision")}</Typography>
      </Box>
    );
  }

  // ðŸ“Š Aplicar mismo orden al grÃ¡fico
  const filteredChartData = sortedRows.filter((r) =>
    chartData.some((c) => c.id === r.id),
  );
  const hasGanttData = filteredChartData.length > 0;

  let startMin = Date.now();
  let endMax = Date.now() + 7 * 24 * 60 * 60 * 1000;
  if (hasGanttData) {
    startMin = Math.min(
      ...filteredChartData.map((d) => new Date(d.inicio).getTime()),
    );
    endMax = Math.max(
      ...filteredChartData.map((d) => new Date(d.fin).getTime()),
    );
  }

  const totalHeight = filteredRows.length * ROW_HEIGHT + 100;

  const groupedByProject = Object.values(
    sortedRows.reduce((acc, row) => {
      if (!acc[row.proyecto]) {
        acc[row.proyecto] = {
          proyecto: row.proyecto,
          tasks: [],
        };
      }
      acc[row.proyecto].tasks.push(row);
      return acc;
    }, {}),
  );

  const getEstadoChipSx = (estado) => {
    const colors = {
      Done: "#2e7d32",
      Running: "#1565c0",
      Pending: "#e65100",
    };
    const color = colors[estado] || theme.palette.text.primary;
    return {
      height: 22,
      fontWeight: 700,
      fontSize: "0.72rem",
      bgcolor: alpha(color, 0.12),
      color,
      border: "1px solid",
      borderColor: alpha(color, 0.3),
    };
  };

  const renderPersonLabel = (username, colorHex) => {
    if (!username) return null;
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          minWidth: 0,
          lineHeight: 1.15,
        }}
      >
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            flexShrink: 0,
            bgcolor: colorHex || theme.palette.text.disabled,
          }}
        />
        <Typography
          component="span"
          sx={{
            fontSize: "0.75rem",
            fontWeight: 600,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {username}
        </Typography>
      </Box>
    );
  };

  const desktopColgroup = (
    <colgroup>
      <col style={{ width: 50 }} />
      <col />
      <col style={{ width: "17%" }} />
      <col style={{ width: "13%" }} />
      <col style={{ width: "18%" }} />
      <col style={{ width: "14%" }} />
    </colgroup>
  );

  const desktopHeaderCellStyle = {
    height: GANTT_HEADER_HEIGHT,
    boxSizing: "border-box",
    padding: "0 6px",
    textAlign: "left",
    verticalAlign: "middle",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "0.85rem",
    userSelect: "none",
    border: "none",
  };

  const handleOpenEdit = (row) => {
    setTareaSeleccionada(row);
    setNuevoEstado(row.estado);
    setNuevaFechaInicio(row.inicio || "");
    setNuevaFechaFin(row.fin || "");
    setOpenEstadoDialog(true);
  };

  const handleOpenChatForRow = (row, e) => {
    e?.stopPropagation();
    setSelectedTarea(row);
    setOpenChat(true);
    setRows((prev) =>
      prev.map((t) => (t.id === row.id ? { ...t, noLeidos: 0 } : t)),
    );
    socket.emit("tareas-mensajes-leidos", { tareaId: row.id });
  };

  const handleOpenDocsForRow = (row, e) => {
    e?.stopPropagation();
    setTareaDocs(row);
    setOpenDocsDialog(true);
  };

  const renderTaskThumbnail = (row, size = 40) => (
    <Box sx={{ position: "relative", display: "inline-block", flexShrink: 0 }}>
      {row.thumbnail ? (
        <Box
          component="img"
          src={row.thumbnail}
          alt="thumbnail"
          sx={{
            width: size,
            height: size,
            borderRadius: 1.5,
            objectFit: "cover",
            cursor: "pointer",
            border: "1px solid",
            borderColor: "divider",
          }}
          onMouseEnter={(e) => {
            if (isMobile) return;
            const rect = e.currentTarget.getBoundingClientRect();
            setHoveredImage(row.thumbnail);
            setHoverPos({ x: rect.right + 10, y: rect.top });
          }}
          onMouseLeave={() => setHoveredImage(null)}
          onClick={(e) => handleOpenDocsForRow(row, e)}
        />
      ) : (
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius: 1.5,
            bgcolor: alpha(theme.palette.background.default, 0.9),
            border: "1px dashed",
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.75rem",
            color: "text.secondary",
            cursor: "pointer",
          }}
          onClick={(e) => handleOpenDocsForRow(row, e)}
        >
          +
        </Box>
      )}
      {row.documentos > 0 ? (
        <Box
          sx={{
            position: "absolute",
            top: -4,
            right: -4,
            bgcolor: theme.palette.secondary.main,
            color: "white",
            borderRadius: "50%",
            width: 18,
            height: 18,
            fontSize: "0.62rem",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {row.documentos}
        </Box>
      ) : null}
    </Box>
  );

  const renderChatDot = (row) => (
    <Box
      title={
        row.noLeidos > 0
          ? `${row.noLeidos} unread`
          : row.hasMessages
            ? "All read"
            : "No messages"
      }
      sx={{
        backgroundColor: row.noLeidos > 0
          ? "#ff0404"
          : row.hasMessages
            ? "#2196f3"
            : "#cccccc",
        color: "white",
        borderRadius: "50%",
        width: 22,
        height: 22,
        fontSize: "0.7rem",
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0,
      }}
      onClick={(e) => handleOpenChatForRow(row, e)}
    >
      {row.noLeidos > 0 ? row.noLeidos : ""}
    </Box>
  );

  const renderMobileTaskCard = (row) => {
    const color = definicionColors[row.definicion] || accent;
    return (
      <Paper
        key={row.id}
        elevation={0}
        onClick={() => handleOpenEdit(row)}
        sx={{
          ...pageMobileCardSx(theme, { accentColor: color }),
          mb: 1,
          cursor: "pointer",
        }}
      >
        <Stack direction="row" spacing={1.25} alignItems="flex-start">
          {renderTaskThumbnail(row, 44)}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {row.definicion ? (
              <Chip
                size="small"
                label={row.definicion}
                sx={{
                  height: 22,
                  mb: 0.5,
                  fontWeight: 700,
                  fontSize: "0.68rem",
                  bgcolor: alpha(color, 0.12),
                  color,
                }}
              />
            ) : null}
            <Stack direction="row" spacing={0.75} alignItems="center">
              {renderChatDot(row)}
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "0.88rem",
                  lineHeight: 1.25,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {row.tarea}
              </Typography>
            </Stack>
            {row.relacionNombre ? (
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.35 }}>
                {row.relacionNombre}
              </Typography>
            ) : null}
            <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={{ mt: 0.75 }}>
              <Chip size="small" label={row.estado} sx={getEstadoChipSx(row.estado)} />
              {row.responsable?.username ? (
                <Chip
                  size="small"
                  label={row.responsable.username}
                  sx={{
                    height: 22,
                    fontSize: "0.68rem",
                    fontWeight: 600,
                    bgcolor: alpha(row.responsable.colorHex || accent, 0.12),
                  }}
                />
              ) : null}
              {row.fin ? (
                <Chip
                  size="small"
                  label={dayjs(row.fin).format("DD/MM/YY")}
                  sx={{ height: 22, fontSize: "0.68rem", fontWeight: 600 }}
                />
              ) : null}
            </Stack>
            <Stack direction="row" spacing={0.75} sx={{ mt: 1 }}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                startIcon={<ChatBubbleOutlineIcon />}
                onClick={(e) => handleOpenChatForRow(row, e)}
                sx={{ textTransform: "none", fontWeight: 700 }}
              >
                Chat
              </Button>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                startIcon={<InsertDriveFileOutlinedIcon />}
                onClick={(e) => handleOpenDocsForRow(row, e)}
                sx={{ textTransform: "none", fontWeight: 700 }}
              >
                Docs
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Paper>
    );
  };

  const renderMobileTaskList = () => (
    <Box sx={{ width: "100%" }}>
      {groupedByProject.map((group) => (
        <Box key={group.proyecto} sx={{ mb: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              mb: 1,
              px: 1.25,
              py: 0.85,
              borderRadius: 2,
              bgcolor: alpha(accent, 0.08),
              border: "1px solid",
              borderColor: alpha(accent, 0.18),
            }}
          >
            <Typography sx={{ fontWeight: 800, fontSize: "0.82rem", lineHeight: 1.2 }}>
              {group.proyecto}
            </Typography>
            <Chip
              size="small"
              label={`${group.tasks.length}`}
              sx={{ height: 22, fontWeight: 700, fontSize: "0.68rem" }}
            />
          </Stack>
          {group.tasks.map((row) => renderMobileTaskCard(row))}
        </Box>
      ))}
    </Box>
  );

  const ganttTotalDays = Math.max(
    1,
    Math.ceil((endMax - startMin) / (1000 * 60 * 60 * 24)),
  );
  const ganttWidth = ganttTotalDays * GANTT_PX_PER_DAY;
  const ganttBodyHeight = groupedByProject.reduce(
    (acc, g) => acc + (g.tasks.length + 1) * ROW_HEIGHT,
    0,
  );

  const desktopColumns = [
    { key: "id", label: "ID" },
    { key: "tarea", label: t("ToDoList.Tarea") },
    { key: "responsable", label: t("ToDoList.Responsable") },
    { key: "estado", label: t("ToDoList.Status") },
    { key: "Elemento", label: t("ToDoList.Elemento") },
    { key: "inicio", label: t("ToDoList.StartEnd") },
  ];

  const renderDesktopTable = () => (
    <Box
      id="todo-table"
      sx={{
        width: showSplitView ? "35%" : "100%",
        minWidth: showSplitView ? 280 : 0,
        maxHeight: showSplitView
          ? "calc(100dvh - 220px)"
          : { xs: "none", md: "calc(100dvh - 280px)" },
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          height: GANTT_HEADER_HEIGHT,
          minHeight: GANTT_HEADER_HEIGHT,
          maxHeight: GANTT_HEADER_HEIGHT,
          flexShrink: 0,
          overflow: "hidden",
          borderBottom: `2px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.background.paper,
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "0.85rem",
            tableLayout: "fixed",
          }}
        >
          {desktopColgroup}
          <thead>
            <tr>
              {desktopColumns.map((col) => (
                <th
                  key={col.key}
                  onClick={() => {
                    if (sortModel?.field === col.key) {
                      setSortModel({
                        field: col.key,
                        sort: sortModel.sort === "asc" ? "desc" : "asc",
                      });
                    } else {
                      setSortModel({ field: col.key, sort: "asc" });
                    }
                  }}
                  style={{
                    ...desktopHeaderCellStyle,
                    cursor: "pointer",
                  }}
                >
                  {col.label}
                  {sortModel?.field === col.key ? (
                    <span style={{ marginLeft: 4 }}>
                      {sortModel.sort === "asc" ? "▲" : "▼"}
                    </span>
                  ) : null}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </Box>
      <Box
        id="todo-table-scroll"
        sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "0.85rem",
            tableLayout: "fixed",
          }}
        >
          {desktopColgroup}
          <tbody>
            {groupedByProject.map((group) => (
              <React.Fragment key={group.proyecto}>
                <tr style={{ height: ROW_HEIGHT }}>
                  <td colSpan={6} style={{ padding: 0, height: ROW_HEIGHT }}>
                    <Box
                      sx={{
                        height: ROW_HEIGHT,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        bgcolor: alpha(theme.palette.divider, 0.1),
                        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.35)}`,
                        px: 2,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.8rem",
                          color: theme.palette.text.primary,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          pr: 1,
                        }}
                      >
                        {group.proyecto}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: theme.palette.text.secondary,
                          fontWeight: 700,
                          flexShrink: 0,
                        }}
                      >
                        {group.tasks.length}{" "}
                        {group.tasks.length > 1 ? "tasks" : "task"}
                      </Typography>
                    </Box>
                  </td>
                </tr>
                {group.tasks.map((row, i) => {
                  const color =
                    definicionColors[row.definicion] ||
                    theme.palette.ganttext?.main ||
                    accent;
                  return (
                    <tr
                      key={row.id}
                      onClick={() => handleOpenEdit(row)}
                      style={{
                        cursor: "pointer",
                        height: ROW_HEIGHT,
                        maxHeight: ROW_HEIGHT,
                        backgroundColor:
                          i % 2 === 0
                            ? alpha(theme.palette.divider, 0.04)
                            : theme.palette.background.paper,
                      }}
                    >
                      <td
                        style={{
                          padding: "0 8px",
                          width: 50,
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        {renderTaskThumbnail(row, 40)}
                      </td>
                      <td
                        style={{
                          padding: "0 8px",
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {row.definicion ? (
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "0.78rem",
                              color: theme.palette.text.primary,
                              lineHeight: 1.15,
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              borderLeft: `3px solid ${color}`,
                              pl: 0.75,
                            }}
                          >
                            {row.definicion}
                          </Typography>
                        ) : null}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mt: row.definicion ? 0.2 : 0,
                            minWidth: 0,
                          }}
                        >
                          {renderChatDot(row)}
                          <Typography
                            sx={{
                              ml: 1,
                              fontSize: "0.8rem",
                              color: theme.palette.text.primary,
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {row.tarea}
                          </Typography>
                        </Box>
                      </td>
                      <td
                        style={{
                          padding: "0 8px",
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {renderPersonLabel(row.creador?.username, row.creador?.colorHex)}
                        {renderPersonLabel(
                          row.responsable?.username,
                          row.responsable?.colorHex,
                        )}
                      </td>
                      <td
                        style={{
                          padding: "0 8px",
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        <Box
                          sx={{
                            px: 1,
                            py: 0.25,
                            borderRadius: 1,
                            display: "inline-block",
                            ...getEstadoChipSx(row.estado),
                          }}
                        >
                          {row.estado}
                        </Box>
                      </td>
                      <td
                        style={{
                          padding: "0 8px",
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {row.relacionNombre ? (
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.8rem",
                              color: theme.palette.text.primary,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {row.relacionNombre}
                          </Typography>
                        ) : null}
                      </td>
                      <td
                        style={{
                          padding: "0 8px",
                          height: ROW_HEIGHT,
                          maxHeight: ROW_HEIGHT,
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {row.inicio ? (
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              fontWeight: 600,
                              color: theme.palette.text.primary,
                              lineHeight: 1.15,
                            }}
                          >
                            {dayjs(row.inicio).format("DD/MM/YYYY")}
                          </Typography>
                        ) : null}
                        {row.fin ? (
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.8rem",
                              color: theme.palette.text.secondary,
                              lineHeight: 1.15,
                            }}
                          >
                            {dayjs(row.fin).format("DD/MM/YYYY")}
                          </Typography>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );

  const searchFieldSx = {
    width: { xs: "100%", sm: 280, md: 320 },
    minWidth: 0,
    ...pageFieldSx(theme),
    "& .MuiInputBase-root": {
      ...pageFieldSx(theme)["& .MuiInputBase-root"],
      backgroundColor: theme.palette.caja?.main || theme.palette.background.paper,
    },
  };

  const statusToggleSx = {
    height: 36,
    borderRadius: 2,
    flexWrap: "wrap",
    "& .MuiToggleButton-root": {
      textTransform: "none",
      fontWeight: 700,
      fontSize: "0.72rem",
      px: 1.5,
      borderColor: alpha(theme.palette.divider, 0.85),
      color: theme.palette.text.secondary,
    },
    "& .Mui-selected": {
      bgcolor: `${accent} !important`,
      color: "#fff !important",
      borderColor: `${accent} !important`,
    },
  };

  const handleExportPDF = async () => {
    // Solo la lista: legible, completa, saltos entre filas (sin Gantt).
    const table = document.getElementById("todo-table");
    const element = table || exportRef.current;
    if (!element) return;

    const chart = document.getElementById("todo-chart");
    const expandTargets = [
      element,
      ...element.querySelectorAll("#todo-table-scroll"),
    ];

    const savedStyles = expandTargets.map((el) => ({
      el,
      maxHeight: el.style.maxHeight,
      height: el.style.height,
      width: el.style.width,
      minWidth: el.style.minWidth,
      maxWidth: el.style.maxWidth,
      overflow: el.style.overflow,
      overflowX: el.style.overflowX,
      overflowY: el.style.overflowY,
      flex: el.style.flex,
      minHeight: el.style.minHeight,
    }));

    const savedScrolls = expandTargets.map((el) => ({
      el,
      scrollTop: el.scrollTop,
      scrollLeft: el.scrollLeft,
    }));

    const savedChartDisplay = chart?.style.display ?? "";

    expandTargets.forEach((el) => {
      el.style.maxHeight = "none";
      el.style.height = "auto";
      el.style.minHeight = "auto";
      el.style.flex = "none";
      el.style.width = "100%";
      el.style.minWidth = "0";
      el.style.maxWidth = "none";
      el.style.overflow = "visible";
      el.style.overflowX = "visible";
      el.style.overflowY = "visible";
      el.scrollTop = 0;
      el.scrollLeft = 0;
    });
    if (chart) chart.style.display = "none";

    try {
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      const scale = Math.min(
        2,
        8192 / Math.max(element.scrollHeight, element.scrollWidth, 1),
      );

      const canvas = await html2canvas(element, {
        scale,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        height: element.scrollHeight,
        width: element.scrollWidth,
      });

      const pdf = new jsPDF("l", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginX = 24;
      const marginY = 28;
      const availableWidth = pageWidth - marginX * 2;
      const availableHeight = pageHeight - marginY * 2;
      const pxPerPt = canvas.width / availableWidth;
      const pageBudgetPx = Math.floor(availableHeight * pxPerPt);

      const elementTop = element.getBoundingClientRect().top;
      const headerEl = element.querySelector("thead")?.closest("div") || null;
      const headerPx = headerEl
        ? Math.round(headerEl.getBoundingClientRect().height * scale)
        : Math.round(GANTT_HEADER_HEIGHT * scale);

      const rowPx = Math.round(ROW_HEIGHT * scale);
      const rowBottoms = Array.from(
        element.querySelectorAll("#todo-table-scroll tbody tr"),
      ).map((tr) =>
        Math.round((tr.getBoundingClientRect().bottom - elementTop) * scale),
      );
      if (rowBottoms.length === 0) {
        for (let y = headerPx + rowPx; y < canvas.height; y += rowPx) {
          rowBottoms.push(y);
        }
      }
      rowBottoms.push(canvas.height);

      const snapBodyEnd = (fromY, budget) => {
        const limit = Math.min(fromY + budget, canvas.height);
        let best = null;
        for (const bottom of rowBottoms) {
          if (bottom > fromY && bottom <= limit) best = bottom;
        }
        if (best != null) return best;
        const next = rowBottoms.find((b) => b > fromY);
        return next != null ? Math.min(next, canvas.height) : canvas.height;
      };

      const makePageImage = (srcY, bodyH, stampHeader) => {
        const outH = stampHeader ? headerPx + bodyH : bodyH;
        if (outH <= 0) return null;

        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = outH;
        const ctx = pageCanvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

        if (stampHeader && headerPx > 0) {
          ctx.drawImage(
            canvas,
            0,
            0,
            canvas.width,
            Math.min(headerPx, canvas.height),
            0,
            0,
            canvas.width,
            Math.min(headerPx, canvas.height),
          );
          if (bodyH > 0) {
            ctx.drawImage(
              canvas,
              0,
              srcY,
              canvas.width,
              bodyH,
              0,
              headerPx,
              canvas.width,
              bodyH,
            );
          }
        } else {
          ctx.drawImage(
            canvas,
            0,
            srcY,
            canvas.width,
            bodyH,
            0,
            0,
            canvas.width,
            bodyH,
          );
        }

        return {
          dataUrl: pageCanvas.toDataURL("image/png"),
          heightPx: outH,
        };
      };

      let srcY = 0;
      let pageIndex = 0;

      while (srcY < canvas.height) {
        const isFirst = srcY === 0;
        const bodyBudget = Math.max(rowPx, pageBudgetPx - headerPx);

        let sliceEnd = isFirst
          ? snapBodyEnd(headerPx, bodyBudget)
          : snapBodyEnd(srcY, bodyBudget);
        if (isFirst && sliceEnd <= headerPx) {
          sliceEnd = Math.min(headerPx + rowPx, canvas.height);
        }

        const sliceStart = isFirst ? 0 : srcY;
        const bodyH = sliceEnd - sliceStart;
        if (bodyH <= 0) break;

        const pageImg = makePageImage(sliceStart, bodyH, !isFirst);
        if (pageImg) {
          if (pageIndex > 0) pdf.addPage();
          pdf.addImage(
            pageImg.dataUrl,
            "PNG",
            marginX,
            marginY,
            availableWidth,
            pageImg.heightPx / pxPerPt,
          );
          pageIndex += 1;
        }

        srcY = sliceEnd;
      }

      pdf.save(`ToDoList-${dayjs().format("YYYYMMDD-HHmm")}.pdf`);
    } finally {
      savedStyles.forEach(
        ({
          el,
          maxHeight,
          height,
          width,
          minWidth,
          maxWidth,
          overflow,
          overflowX,
          overflowY,
          flex,
          minHeight,
        }) => {
          el.style.maxHeight = maxHeight;
          el.style.height = height;
          el.style.width = width;
          el.style.minWidth = minWidth;
          el.style.maxWidth = maxWidth;
          el.style.minHeight = minHeight;
          el.style.flex = flex;
          el.style.overflow = overflow;
          el.style.overflowX = overflowX;
          el.style.overflowY = overflowY;
        },
      );
      savedScrolls.forEach(({ el, scrollTop, scrollLeft }) => {
        el.scrollTop = scrollTop;
        el.scrollLeft = scrollLeft;
      });
      if (chart) chart.style.display = savedChartDisplay;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        pt: 2,
        pl: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, md: 3 },
        pb: { xs: 10, sm: 2 },
        ...contentMargin,
      }}
    >
      <Box sx={pageHeroShellSx(theme, { sticky: !isMobile })}>
        <Box sx={{ p: { xs: 1.25, sm: 1.75 } }}>
          <Stack
            direction={{ xs: "column", lg: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", lg: "flex-start" }}
            spacing={1.5}
          >
            <Stack direction="row" spacing={1.25} alignItems="flex-start">
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(accent, 0.16),
                  color: theme.palette.primary.dark,
                  border: "1px solid",
                  borderColor: alpha(accent, 0.28),
                }}
              >
                <TaskAltOutlinedIcon fontSize="small" />
              </Box>
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  sx={{ fontWeight: 700, letterSpacing: 1.1 }}
                >
                  CRM
                </Typography>
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  sx={{ fontWeight: 800, lineHeight: 1.1 }}
                >
                  {t("ToDoList.ToDoList")}
                </Typography>
                <Chip
                  size="small"
                  label={`${filteredRows.length} ${t("ToDoList.Tarea", { defaultValue: "tareas" }).toLowerCase()}`}
                  sx={{
                    mt: 0.75,
                    fontWeight: 700,
                    bgcolor: alpha(accent, 0.1),
                    color: theme.palette.primary.dark,
                  }}
                />
              </Box>
            </Stack>

            <Stack spacing={1.25} sx={{ width: { xs: "100%", lg: "auto" } }}>
              <TextField
                label={t("Clientes.search", { defaultValue: "Buscar" })}
                placeholder="Tarea, proyecto, responsable..."
                variant="outlined"
                size="small"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value.toLowerCase())}
                sx={searchFieldSx}
              />
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
                alignItems="center"
              >
                <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={showDone}
                  onChange={(e, newValue) => newValue && setShowDone(newValue)}
                  sx={statusToggleSx}
                >
                  <ToggleButton value="all">{t("ToDoList.Todos")}</ToggleButton>
                  <ToggleButton value="ongoing">{t("ToDoList.InProgress")}</ToggleButton>
                  <ToggleButton value="finished">{t("ToDoList.Completed")}</ToggleButton>
                </ToggleButtonGroup>
                {!isMobile ? (
                  <>
                    <IconButton
                      onClick={handleExportPDF}
                      sx={{
                        border: "1px solid",
                        borderColor: alpha(accent, 0.35),
                        bgcolor: theme.palette.background.paper,
                      }}
                    >
                      <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      onClick={() => setOpenAddDialog(true)}
                      sx={{
                        border: "1px solid",
                        borderColor: alpha(accent, 0.45),
                        bgcolor: theme.palette.background.paper,
                        color: accent,
                      }}
                    >
                      <Add fontSize="small" />
                    </IconButton>
                  </>
                ) : null}
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Box>

      {!showSplitView ? (
        <ToggleButtonGroup
          exclusive
          size="small"
          value={panelView}
          onChange={(e, v) => v && setPanelView(v)}
          sx={{ ...statusToggleSx, mb: 1.5, width: isMobile ? "100%" : "auto" }}
        >
          <ToggleButton value="list" sx={{ flex: isMobile ? 1 : "none" }}>
            <ViewListOutlinedIcon sx={{ fontSize: 18, mr: 0.75 }} />
            Lista
          </ToggleButton>
          <ToggleButton value="gantt" sx={{ flex: isMobile ? 1 : "none" }}>
            <TimelineOutlinedIcon sx={{ fontSize: 18, mr: 0.75 }} />
            Gantt
          </ToggleButton>
        </ToggleButtonGroup>
      ) : null}

      <Box
        ref={exportRef}
        sx={{
          display: "flex",
          flexDirection: showSplitView ? "row" : "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: { xs: 1.5, lg: 1 },
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: showSplitView ? "row" : "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: { xs: 1.5, lg: 1 },
            width: "100%",
          }}
        >
          {isMobile && (showSplitView || panelView === "list")
            ? renderMobileTaskList()
            : null}

          {!isMobile && (showSplitView || panelView === "list")
            ? renderDesktopTable()
            : null}

          {(showSplitView || panelView === "gantt") && hasGanttData ? (
          <Box
            id="todo-chart"
            sx={{
              flex: 1,
              width: showSplitView ? "65%" : "100%",
              minWidth: showSplitView ? "65%" : 0,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              backgroundColor: theme.palette.background.paper,
              display: "flex",
              flexDirection: "column",
              position: "relative",
              maxHeight: { xs: "calc(100dvh - 280px)", lg: "calc(100dvh - 220px)" },
              overflow: "hidden",
            }}
          >
            {/* ðŸ” Cabecera de fechas sticky */}
            <Box
              sx={{
                height: GANTT_HEADER_HEIGHT,
                minHeight: GANTT_HEADER_HEIGHT,
                maxHeight: GANTT_HEADER_HEIGHT,
                position: "sticky",
                top: 0,
                zIndex: 2,
                backgroundColor: theme.palette.background.paper,
                borderBottom: `2px solid ${theme.palette.divider}`,
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <svg
                id="todo-chart-header"
                width={ganttWidth}
                height={GANTT_HEADER_HEIGHT}
                style={{ display: "block" }}
              >
                <rect
                  x="0"
                  y="0"
                  width="100%"
                  height={GANTT_HEADER_HEIGHT}
                  fill={theme.palette.background.paper}
                />
                {Array.from({ length: ganttTotalDays }).map((_, i) => {
                  const date = dayjs(startMin).add(i, "day");
                  const x = (i / ganttTotalDays) * ganttWidth;
                  const isWeekend = date.day() === 0 || date.day() === 6;
                  return (
                    <g key={i}>
                      {isWeekend ? (
                        <rect
                          x={x}
                          y={0}
                          width={GANTT_PX_PER_DAY}
                          height={GANTT_HEADER_HEIGHT}
                          fill={alpha(theme.palette.divider, 0.05)}
                        />
                      ) : null}
                      {i % 2 === 0 ? (
                        <text
                          x={x + GANTT_PX_PER_DAY / 2}
                          y={GANTT_HEADER_HEIGHT / 2 + 4}
                          fontSize="11"
                          fontWeight="600"
                          textAnchor="middle"
                          fill={theme.palette.text.primary}
                        >
                          {date.format("DD/MM")}
                        </text>
                      ) : null}
                      <line
                        x1={x}
                        x2={x}
                        y1={0}
                        y2={GANTT_HEADER_HEIGHT}
                        stroke="#e0e0e0"
                        strokeWidth="1"
                      />
                    </g>
                  );
                })}
                {(() => {
                  const today = Date.now();
                  if (today < startMin || today > endMax) return null;
                  const x = ((today - startMin) / (endMax - startMin)) * ganttWidth;
                  return (
                    <>
                      <line
                        x1={x}
                        x2={x}
                        y1={0}
                        y2={GANTT_HEADER_HEIGHT}
                        stroke="#e53935"
                        strokeDasharray="4 2"
                        strokeWidth="1.5"
                      />
                      <text
                        x={x + 5}
                        y={14}
                        fill="#e53935"
                        fontWeight="bold"
                        fontSize="11"
                      >
                        Hoy
                      </text>
                    </>
                  );
                })()}
              </svg>
            </Box>

            {/* ðŸ”½ Cuerpo del Gantt scrollable */}
            <Box
              id="todo-chart-body"
              sx={{
                flex: 1,
                overflowX: "auto",
                overflowY: "auto",
                position: "relative",
              }}
              onScroll={(e) => {
                const header = document.getElementById("todo-chart-header");
                if (header)
                  header.style.transform = `translateX(-${e.target.scrollLeft}px)`;
              }}
            >
              <svg
                width={ganttWidth}
                height={ganttBodyHeight}
                style={{
                  display: "block",
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                {Array.from({ length: ganttTotalDays }).map((_, i) => {
                  const date = dayjs(startMin).add(i, "day");
                  const x = (i / ganttTotalDays) * ganttWidth;
                  const isWeekend = date.day() === 0 || date.day() === 6;
                  if (!isWeekend) return null;
                  return (
                    <rect
                      key={`weekend-${i}`}
                      x={x}
                      y={0}
                      width={GANTT_PX_PER_DAY}
                      height={ganttBodyHeight}
                      fill={alpha(theme.palette.divider, 0.06)}
                    />
                  );
                })}
                {(() => {
                  let yOffset = 0;
                  const elements = [];

                  groupedByProject.forEach((group) => {
                    elements.push(
                      <g key={`header-${group.proyecto}`}>
                        <rect
                          x="0"
                          y={yOffset}
                          width="100%"
                          height={ROW_HEIGHT}
                          fill={alpha(theme.palette.divider, 0.1)}
                        />
                        <line
                          x1="0"
                          x2="100%"
                          y1={yOffset + ROW_HEIGHT}
                          y2={yOffset + ROW_HEIGHT}
                          stroke={alpha(theme.palette.divider, 0.35)}
                          strokeWidth="1"
                        />
                      </g>,
                    );

                    yOffset += ROW_HEIGHT;

                    group.tasks.forEach((r, i) => {
                      elements.push(
                        <rect
                          key={`bg-${r.id}`}
                          x="0"
                          y={yOffset}
                          width="100%"
                          height={ROW_HEIGHT}
                          fill={
                            i % 2 === 0
                              ? alpha(theme.palette.divider, 0.04)
                              : theme.palette.background.paper
                          }
                        />,
                      );

                      if (r.inicio && r.fin) {
                        const xStart =
                          ((new Date(r.inicio).getTime() - startMin) /
                            (endMax - startMin)) *
                          ganttWidth;
                        const xEnd =
                          ((new Date(r.fin).getTime() - startMin) /
                            (endMax - startMin)) *
                          ganttWidth;
                        const y = yOffset + ROW_HEIGHT / 2;
                        const color =
                          r.estado === "Done"
                            ? "#4caf50"
                            : r.estado === "Running"
                              ? "#2196f3"
                              : "#fbc02d";

                        elements.push(
                          <g key={`task-${r.id}`}>
                            <line
                              x1={xStart}
                              x2={xEnd}
                              y1={y}
                              y2={y}
                              stroke={color}
                              strokeWidth="6"
                              strokeLinecap="round"
                              opacity="0.8"
                            />
                            <circle
                              cx={xEnd}
                              cy={y}
                              r="5"
                              fill={color}
                              stroke="#333"
                              strokeWidth="0.8"
                            />
                            <text
                              x={xEnd + 8}
                              y={y + 3}
                              fontSize="10"
                              fill="#555"
                            >
                              {dayjs(r.fin).format("DD/MM")}
                            </text>
                          </g>,
                        );
                      }

                      yOffset += ROW_HEIGHT;
                    });
                  });

                  return elements;
                })()}
                {(() => {
                  const today = Date.now();
                  if (today < startMin || today > endMax) return null;
                  const x =
                    ((today - startMin) / (endMax - startMin)) * ganttWidth;

                  return (
                    <g key="today-line">
                      <line
                        x1={x}
                        x2={x}
                        y1={0}
                        y2={ganttBodyHeight}
                        stroke="#e53935"
                        strokeWidth="1.5"
                        strokeDasharray="4 2"
                        opacity={0.85}
                      />
                    </g>
                  );
                })()}
              </svg>
            </Box>
          </Box>
          ) : (showSplitView || panelView === "gantt") && !hasGanttData ? (
            <Box
              sx={{
                width: "100%",
                p: 3,
                borderRadius: 2,
                border: "1px dashed",
                borderColor: "divider",
                textAlign: "center",
              }}
            >
              <Typography color="text.secondary" sx={{ fontWeight: 600 }}>
                No hay tareas con fechas para mostrar en el Gantt.
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Box>

      {isMobile ? (
        <Fab
          color="primary"
          onClick={() => setOpenAddDialog(true)}
          sx={{
            position: "fixed",
            right: 20,
            bottom: 20,
            zIndex: 30,
          }}
        >
          <Add />
        </Fab>
      ) : null}

      {/* ðŸªŸ DiÃ¡logo de ediciÃ³n de tarea */}
      <Dialog
        open={openEstadoDialog}
        onClose={() => setOpenEstadoDialog(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 3,
            m: isMobile ? 0 : 2,
            overflow: "hidden",
            bgcolor: theme.palette.background.default,
          },
        }}
      >
        <Box sx={{ ...pageHeroShellSx(theme), mb: 0, borderRadius: 0 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: { xs: 1.5, sm: 2 } }}
          >
            <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(accent, 0.16),
                  color: theme.palette.primary.dark,
                  border: "1px solid",
                  borderColor: alpha(accent, 0.28),
                }}
              >
                <TaskAltOutlinedIcon fontSize="small" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  sx={{ fontWeight: 700, letterSpacing: 1.1, lineHeight: 1.2 }}
                >
                  CRM
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 800, lineHeight: 1.15, fontSize: { xs: "1.05rem", sm: "1.2rem" } }}
                >
                  {t("ToDoList.EditTask")}
                </Typography>
                {tareaSeleccionada?.definicion ? (
                  <Chip
                    size="small"
                    label={tareaSeleccionada.definicion}
                    sx={{
                      mt: 0.5,
                      height: 22,
                      fontWeight: 700,
                      fontSize: "0.68rem",
                      maxWidth: "100%",
                      bgcolor: alpha(accent, 0.1),
                      color: theme.palette.primary.dark,
                    }}
                  />
                ) : null}
              </Box>
            </Stack>
            {isMobile ? (
              <IconButton
                onClick={() => setOpenEstadoDialog(false)}
                sx={{
                  border: "1px solid",
                  borderColor: alpha(theme.palette.divider, 0.8),
                  bgcolor: theme.palette.background.paper,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            ) : null}
          </Stack>
        </Box>
        <DialogContent
          sx={{
            px: { xs: 1.5, sm: 2.5 },
            py: 2,
            pb: { xs: 3, sm: 2.5 },
          }}
        >
          {tareaSeleccionada ? (
            <EditTareaDialogContent
              tarea={tareaSeleccionada}
              onClose={() => setOpenEstadoDialog(false)}
              onUpdated={(updated) => {
                if (updated._deleted) {
                  // ðŸ—‘ï¸ Si se ha eliminado, la quitamos de las filas y del grÃ¡fico
                  const filtered = rows.filter((t) => t.id !== updated.id);
                  setRows(filtered);
                  setChartData(filtered.filter((r) => r.fin));
                  return;
                }

                // ðŸ” Actualiza filas y grÃ¡fico despuÃ©s de editar
                const newRows = rows.map((t) =>
                  t.id === updated.id ? updated : t,
                );
                setRows(newRows);
                setChartData(newRows.filter((r) => r.fin));
              }}
            />
          ) : (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* ðŸªŸ DiÃ¡logo Documentos Tarea */}
      {/* ðŸ—‚ï¸ DiÃ¡logo para ver documentos de la tarea */}
      <Dialog
        open={openDocsDialog}
        onClose={() => setOpenDocsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Documents for task:{" "}
          <strong>{tareaDocs?.definicion || tareaDocs?.tarea}</strong>
        </DialogTitle>
        <DialogContent>
          {tareaDocs && (
            <DocumentosTareas
              id_Tarea={tareaDocs.id}
              onDocsChange={() =>
                refreshDocsCount(tareaDocs.id)
              } /*  âœ… refresco automÃ¡tico */
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDocsDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <AddTareas
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        onCreated={async (t) => {
          if (!t) return;

          try {
            const [
              proyectos,
              usuarios,
              definiciones,
              disenos,
              muestras,
              materiales,
            ] = await Promise.all([
              getAllProyectos(),
              getAllUsers(),
              getTareasDefinicion(),
              getDisenos(),
              getMuestras(),
              getMateriales(),
            ]);

            // ðŸ”‘ MAPS POR ID
            const proyectosMap = proyectos.reduce((acc, p) => {
              acc[p.id] = p.subject || `Proyecto ${p.id}`;
              return acc;
            }, {});

            const usuariosMap = usuarios.reduce((acc, u) => {
              acc[u.id] = u;
              return acc;
            }, {});

            const definicionesMap = definiciones.reduce((acc, d) => {
              acc[d.Id] = d.Nombre;
              return acc;
            }, {});

            const disenosMap = disenos.reduce((acc, d) => {
              acc[d.id] = d;
              return acc;
            }, {});

            const muestrasMap = muestras.reduce((acc, m) => {
              acc[m.ID_MUESTRA] = m;
              return acc;
            }, {});

            const materialesMap = materiales.reduce((acc, m) => {
              acc[m.Id] = m;
              return acc;
            }, {});

            // ðŸ§© Nombre de relaciÃ³n (SIN .find)
            let relacionNombre = "";

            if (t.RelacionTipo === "DiseÃ±o") {
              relacionNombre =
                disenosMap[t.RelacionId]?.nombre || `DiseÃ±o ID ${t.RelacionId}`;
            } else if (t.RelacionTipo === "Muestra") {
              relacionNombre =
                muestrasMap[t.RelacionId]?.MUESTRA ||
                `Muestra ID ${t.RelacionId}`;
            } else if (t.RelacionTipo === "Material") {
              relacionNombre =
                materialesMap[t.RelacionId]?.NombreMaterial ||
                `Material ID ${t.RelacionId}`;
            }

            // ðŸ”¹ Tarea formateada igual que las demÃ¡s
            const nuevaFormateada = {
              id: t.Id,
              tarea: t.Descripcion,
              definicion: definicionesMap[t.TituloId] || "",
              estado: t.Estado || "Pending",
              fin: t.FechaLimite,
              inicio: t.FechaInicio || dayjs().format("YYYY-MM-DD"),
              proyecto: proyectosMap[t.ProyectoId] || "â€”",
              responsable: usuariosMap[t.ResponsableId] || {},
              creador: usuariosMap[t.CreadorId] || {},
              relacionTipo: t.RelacionTipo,
              relacionNombre,
              documentos: 0,
              noLeidos: 0,
              hasMessages: false,
            };

            setRows((prev) => [nuevaFormateada, ...prev]);
            if (nuevaFormateada.fin) {
              setChartData((prev) => [nuevaFormateada, ...prev]);
            }

            setOpenAddDialog(false);
          } catch (error) {
            console.error("âŒ Error mapeando nueva tarea:", error);
          }
        }}
      />

      <TareaChat
        open={openChat}
        onClose={() => setOpenChat(false)}
        tarea={selectedTarea}
      />

      {hoveredImage && (
        <Box
          sx={{
            position: "fixed",
            top: hoverPos.y,
            left: hoverPos.x,
            zIndex: 2000,
            pointerEvents: "none",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            p: 0.5,
          }}
        >
          <Box
            component="img"
            src={hoveredImage}
            alt="preview"
            sx={{
              width: 420,
              height: 420,
              objectFit: "cover",
              borderRadius: "6px",
            }}
          />
        </Box>
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          sx={{
            width: "100%",
            boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
            borderRadius: 2,
            backgroundColor: "#fff8e1",
            color: "#795548",
            fontWeight: 500,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

const EditTareaDialogContent = ({ tarea, onClose, onUpdated }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const fieldSx = pageFieldSx(theme);
  const [loading, setLoading] = useState(true);
  const [definiciones, setDefiniciones] = useState([]);
  const [responsables, setResponsables] = useState([]);
  const [relaciones, setRelaciones] = useState([]);
  const [relacionTipo, setRelacionTipo] = useState(
    tarea.relacionTipo || "Diseño",
  );
  const [proyectos, setProyectos] = useState([]);
  const [errors, setErrors] = useState({});
  const [searchText, setSearchText] = useState("");
  const [loadingRelaciones, setLoadingRelaciones] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [initialParticipanteIds, setInitialParticipanteIds] = useState([]);

  // ðŸ”´ DiÃ¡logo de confirmaciÃ³n de eliminaciÃ³n
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [form, setForm] = useState({
    ProyectoId: "",
    TituloId: "",
    Descripcion: "",
    ResponsableId: "",
    RelacionTipo: "Diseño",
    RelacionId: "",
    FechaInicio: "",
    FechaLimite: "",
    Estado: "Pending",
  });

  // ðŸ§© Carga inicial de datos
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const tareaId = tarea.id || tarea.Id;
        const [proy, defs, resp, disenos, muestras, materiales, parts] =
          await Promise.all([
            getAllProyectos(),
            getTareasDefinicion(),
            getAllUsers(),
            getDisenos(),
            getMuestras(),
            getMateriales(),
            tareaId ? getTareasParticipantes(tareaId).catch(() => []) : Promise.resolve([]),
          ]);

        setProyectos(proy);
        setDefiniciones(defs);
        setResponsables((resp || []).filter(isSelectableUser));

        // ðŸ‘‡ selecciona relaciones segÃºn el tipo
        let rels = [];
        if (tarea.relacionTipo === "Muestra") rels = muestras;
        else if (tarea.relacionTipo === "Material") rels = materiales;
        else rels = disenos;
        setRelaciones(rels);

        // ðŸ‘‡ busca el ID de relaciÃ³n correcto segÃºn el nombre
        let relacionId = "";
        if (tarea.relacionNombre) {
          const match =
            rels.find(
              (r) =>
                r.nombre === tarea.relacionNombre ||
                r.MUESTRA === tarea.relacionNombre ||
                r.NombreMaterial === tarea.relacionNombre,
            ) || null;
          if (match)
            relacionId = match.id || match.Id || match.ID_MUESTRA || "";
        }

        const responsableId =
          resp.find((r) =>
            typeof tarea.responsable === "object"
              ? r.id === tarea.responsable.id
              : r.username === tarea.responsable,
          )?.id || "";

        const partsList = Array.isArray(parts) ? parts : [];
        const partsWithoutResponsable = partsList.filter(
          (p) => Number(p.id) !== Number(responsableId),
        );
        setParticipantes(partsWithoutResponsable);
        setInitialParticipanteIds(
          partsWithoutResponsable.map((p) => Number(p.id)),
        );

        // âœ… rellena formulario completo
        setForm({
          ProyectoId: proy.find((p) => p.subject === tarea.proyecto)?.id || "",
          TituloId: defs.find((d) => d.Nombre === tarea.definicion)?.Id || "",
          Descripcion: tarea.tarea || "",
          ResponsableId: responsableId,
          RelacionTipo: tarea.relacionTipo || "Diseño",
          RelacionId: relacionId,
          FechaInicio: dayjs(tarea.inicio).format("YYYY-MM-DD") || "",
          FechaLimite: dayjs(tarea.fin).format("YYYY-MM-DD") || "",
          Estado: tarea.estado || "Pending",
        });
      } catch (err) {
        console.error("âŒ Error cargando datos ediciÃ³n:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [tarea]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
    if (field === "ResponsableId") {
      setParticipantes((prev) =>
        prev.filter((u) => Number(u.id) !== Number(value)),
      );
    }
  };

  const handleRelacionTipo = async (tipo) => {
    setRelacionTipo(tipo);
    setForm((prev) => ({ ...prev, RelacionTipo: tipo, RelacionId: "" }));
    setLoadingRelaciones(true);
    try {
      if (tipo === "Diseño") setRelaciones(await getDisenos());
      if (tipo === "Muestra") setRelaciones(await getMuestras());
      if (tipo === "Material") setRelaciones(await getMateriales());
    } catch (err) {
      console.error("âŒ Error cargando relaciones:", err);
    } finally {
      setLoadingRelaciones(false);
    }
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!form.ProyectoId) newErrors.ProyectoId = t("ToDoList.Project");
    if (!form.TituloId) newErrors.TituloId = "Select a definition";
    if (!form.ResponsableId) newErrors.ResponsableId = "Select a responsible";
    if (!form.FechaInicio) newErrors.FechaInicio = "Select start date";
    if (!form.FechaLimite) newErrors.FechaLimite = "Select due date";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      // ðŸ§© Log de depuraciÃ³n temporal
      console.log("ðŸ§© Enviando actualizaciÃ³n tarea:", {
        Id: tarea.id,
        ProyectoId: form.ProyectoId,
        TituloId: form.TituloId,
        Descripcion: form.Descripcion,
        ResponsableId: form.ResponsableId,
        RelacionTipo: form.RelacionTipo,
        RelacionId: form.RelacionId,
        FechaInicio: form.FechaInicio,
        FechaLimite: form.FechaLimite,
        Estado: form.Estado,
      });

      // âœ… AsegÃºrate de pasar el campo correcto del backend (Id vs id)
      const tareaId = tarea.id || tarea.Id;
      await updateTarea(tareaId, {
        ProyectoId: form.ProyectoId,
        TituloId: form.TituloId,
        Descripcion: form.Descripcion,
        ResponsableId: form.ResponsableId,
        RelacionTipo: form.RelacionTipo,
        RelacionId: form.RelacionId || null, // ðŸ‘ˆ evita string vacÃ­o
        FechaInicio: form.FechaInicio,
        FechaLimite: form.FechaLimite,
        Estado: form.Estado,
      });

      const nextIds = participantes
        .map((p) => Number(p.id))
        .filter((id) => Number.isFinite(id) && id !== Number(form.ResponsableId));
      const prevIds = initialParticipanteIds.filter(
        (id) => id !== Number(form.ResponsableId),
      );
      const toAdd = nextIds.filter((id) => !prevIds.includes(id));
      const toRemove = prevIds.filter((id) => !nextIds.includes(id));

      await Promise.all([
        ...toAdd.map((userId) =>
          postTareasParticipante(tareaId, { UserId: userId }),
        ),
        ...toRemove.map((userId) =>
          deleteTareasParticipante(tareaId, userId),
        ),
      ]);

      // ðŸ§© Construye el nuevo objeto localmente
      const rel =
        relaciones.find(
          (r) =>
            r.id === form.RelacionId ||
            r.Id === form.RelacionId ||
            r.ID_MUESTRA === form.RelacionId,
        ) || {};

      const updated = {
        ...tarea,
        definicion:
          definiciones.find((d) => d.Id === form.TituloId)?.Nombre ||
          tarea.definicion,
        responsable:
          responsables.find((r) => r.id === form.ResponsableId) ||
          tarea.responsable,
        proyecto:
          proyectos.find((p) => p.id === form.ProyectoId)?.subject ||
          tarea.proyecto,
        tarea: form.Descripcion,
        estado: form.Estado,
        inicio: form.FechaInicio,
        fin: form.FechaLimite,
        relacionTipo: form.RelacionTipo,
        relacionNombre:
          rel.nombre ||
          rel.MUESTRA ||
          rel.NombreMaterial ||
          tarea.relacionNombre,
        ParticipanteIds: nextIds,
      };

      onUpdated(updated);
      onClose();
    } catch (err) {
      console.error("âŒ Error actualizando tarea:", err);
    }
  };

  const accent = theme.palette.primary.main;
  const sectionCardSx = {
    ...pageContentCardSx(theme, accent),
    p: { xs: 1.5, sm: 2 },
  };

  if (loading)
    return (
      <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ py: 6 }}>
        <CircularProgress size={32} />
        <Typography variant="body2" color="text.secondary" fontWeight={600}>
          {t("ToDoList.EditTask")}
        </Typography>
      </Stack>
    );

  const estadoColors = {
    Done: "#2e7d32",
    Running: "#1565c0",
    Pending: "#e65100",
  };

  const estadoLabel =
    form.Estado === "Done"
      ? t("ToDoList.Done")
      : form.Estado === "Running"
        ? t("ToDoList.Running")
        : t("ToDoList.Pending");

  return (
    <>
      <Stack spacing={1.75}>
        <Box sx={sectionCardSx}>
          <Typography sx={pageSectionTitleSx}>{t("ToDoList.Project")}</Typography>
          <Stack spacing={1.5} sx={{ mt: 1.25 }}>
            <Autocomplete
              fullWidth
              size="small"
              options={[...proyectos].sort((a, b) =>
                (a.subject || "").localeCompare(b.subject || "", "es", {
                  sensitivity: "base",
                }),
              )}
              value={proyectos.find((p) => p.id === form.ProyectoId) || null}
              getOptionLabel={(p) =>
                p?.subject?.trim?.() || `Proyecto ${p?.id || ""}`
              }
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              onChange={(e, newValue) =>
                handleChange("ProyectoId", newValue?.id || "")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("ToDoList.Project")}
                  placeholder="Search project..."
                  error={!!errors.ProyectoId}
                  helperText={errors.ProyectoId}
                  sx={fieldSx}
                />
              )}
            />

            <FormControl fullWidth size="small" sx={fieldSx}>
              <InputLabel>{t("ToDoList.Tarea")}</InputLabel>
              <Select
                value={form.TituloId}
                label={t("ToDoList.Tarea")}
                onChange={(e) => handleChange("TituloId", e.target.value)}
              >
                {[...definiciones]
                  .sort((a, b) =>
                    a.Nombre.localeCompare(b.Nombre, "es", { sensitivity: "base" }),
                  )
                  .map((d) => (
                    <MenuItem key={d.Id} value={d.Id}>
                      {d.Nombre}
                    </MenuItem>
                  ))}
              </Select>
              {errors.TituloId ? (
                <Typography variant="caption" color="error">
                  {errors.TituloId}
                </Typography>
              ) : null}
            </FormControl>
          </Stack>
        </Box>

        <Box sx={sectionCardSx}>
          <Typography sx={pageSectionTitleSx}>{t("ToDoList.Responsable")}</Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ mt: 1.25 }}
          >
            <FormControl fullWidth size="small" error={!!errors.ResponsableId} sx={fieldSx}>
              <InputLabel>{t("ToDoList.Responsable")}</InputLabel>
              <Select
                value={form.ResponsableId}
                label={t("ToDoList.Responsable")}
                onChange={(e) => handleChange("ResponsableId", e.target.value)}
              >
                {responsables.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.username}
                  </MenuItem>
                ))}
              </Select>
              {errors.ResponsableId ? (
                <Typography variant="caption" color="error">
                  {errors.ResponsableId}
                </Typography>
              ) : null}
            </FormControl>

            <FormControl fullWidth size="small" sx={fieldSx}>
              <InputLabel id="estado-label">{t("ToDoList.Status")}</InputLabel>
              <Select
                labelId="estado-label"
                label={t("ToDoList.Status")}
                value={form.Estado}
                onChange={(e) => handleChange("Estado", e.target.value)}
                renderValue={() => (
                  <Chip
                    size="small"
                    label={estadoLabel}
                    sx={{
                      height: 24,
                      fontWeight: 700,
                      fontSize: "0.72rem",
                      bgcolor: alpha(
                        estadoColors[form.Estado] || theme.palette.text.primary,
                        0.12,
                      ),
                      color: estadoColors[form.Estado] || theme.palette.text.primary,
                      border: "1px solid",
                      borderColor: alpha(
                        estadoColors[form.Estado] || theme.palette.text.primary,
                        0.28,
                      ),
                    }}
                  />
                )}
              >
                <MenuItem value="Pending">{t("ToDoList.Pending")}</MenuItem>
                <MenuItem value="Running">{t("ToDoList.Running")}</MenuItem>
                <MenuItem value="Done">{t("ToDoList.Done")}</MenuItem>
              </Select>
            </FormControl>
          </Stack>

          <Autocomplete
            multiple
            fullWidth
            size="small"
            sx={{ ...fieldSx, mt: 1.5 }}
            options={responsables.filter(
              (u) => Number(u.id) !== Number(form.ResponsableId),
            )}
            value={participantes}
            onChange={(_, value) => setParticipantes(value || [])}
            getOptionLabel={(u) => u?.username || `User ${u?.id || ""}`}
            isOptionEqualToValue={(opt, val) =>
              Number(opt.id) === Number(val.id)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Participants"
                placeholder="Add people who can see this task"
              />
            )}
          />
        </Box>

        <Box sx={sectionCardSx}>
          <Typography sx={pageSectionTitleSx}>{t("ToDoList.objeto")}</Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ mt: 1.25 }}
          >
            <FormControl fullWidth size="small" sx={fieldSx}>
              <InputLabel>{t("ToDoList.objeto")}</InputLabel>
              <Select
                value={relacionTipo}
                label={t("ToDoList.objeto")}
                onChange={(e) => handleRelacionTipo(e.target.value)}
              >
                <MenuItem value="Diseño">{t("ToDoList.Diseño")}</MenuItem>
                <MenuItem value="Muestra">{t("ToDoList.Muestra")}</MenuItem>
                <MenuItem value="Material">{t("ToDoList.Material")}</MenuItem>
              </Select>
            </FormControl>

            <Autocomplete
              fullWidth
              size="small"
              sx={fieldSx}
              options={relaciones}
              loading={loadingRelaciones}
              onInputChange={(e, value) => setSearchText(value)}
              value={
                relaciones.find(
                  (r) =>
                    r.id === form.RelacionId ||
                    r.Id === form.RelacionId ||
                    r.ID_MUESTRA === form.RelacionId,
                ) || null
              }
              getOptionLabel={(r) =>
                r?.nombre ||
                r?.MUESTRA ||
                r?.NombreMaterial ||
                `Elemento ${r?.id || ""}`
              }
              isOptionEqualToValue={(opt, val) =>
                opt.id === val.id ||
                opt.Id === val.Id ||
                opt.ID_MUESTRA === val.ID_MUESTRA
              }
              onChange={(e, newValue) =>
                handleChange(
                  "RelacionId",
                  newValue?.id || newValue?.ID_MUESTRA || newValue?.Id || "",
                )
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("ToDoList.Elemento")}
                  placeholder={t("Clientes.Buscar")}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingRelaciones ? <CircularProgress size={18} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Stack>
        </Box>

        <Box sx={sectionCardSx}>
          <Typography sx={pageSectionTitleSx}>{t("ToDoList.Descripcion")}</Typography>
          <Stack spacing={1.5} sx={{ mt: 1.25 }}>
            <TextField
              label={t("ToDoList.Descripcion")}
              multiline
              minRows={3}
              value={form.Descripcion}
              onChange={(e) => handleChange("Descripcion", e.target.value)}
              fullWidth
              size="small"
              sx={fieldSx}
            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label={t("ToDoList.Start")}
                InputLabelProps={{ shrink: true }}
                value={form.FechaInicio}
                onChange={(e) => handleChange("FechaInicio", e.target.value)}
                error={!!errors.FechaInicio}
                helperText={errors.FechaInicio}
                sx={fieldSx}
              />
              <TextField
                fullWidth
                size="small"
                type="date"
                label={t("ToDoList.End")}
                InputLabelProps={{ shrink: true }}
                value={form.FechaLimite}
                onChange={(e) => handleChange("FechaLimite", e.target.value)}
                error={!!errors.FechaLimite}
                helperText={errors.FechaLimite}
                sx={fieldSx}
              />
            </Stack>
          </Stack>
        </Box>
      </Stack>

      <Box
        sx={{
          position: { xs: "sticky", sm: "static" },
          bottom: 0,
          zIndex: 2,
          mt: 2,
          mx: { xs: -1.5, sm: 0 },
          px: { xs: 1.5, sm: 0 },
          pt: 1.5,
          pb: { xs: 1, sm: 0 },
          bgcolor: alpha(theme.palette.background.default, 0.92),
          backdropFilter: "blur(10px)",
          borderTop: "1px solid",
          borderColor: alpha(theme.palette.divider, 0.7),
        }}
      >
        <Stack
          spacing={1.25}
          sx={{
            flexDirection: { xs: "column-reverse", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
          }}
        >
          <Button
            color="error"
            variant="outlined"
            onClick={() => setOpenDeleteDialog(true)}
            disabled={deleting}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              whiteSpace: "nowrap",
              borderRadius: 2,
              borderColor: alpha(theme.palette.error.main, 0.35),
              bgcolor: alpha(theme.palette.error.main, 0.04),
            }}
          >
            {t("ToDoList.delete")}
          </Button>

          <Stack direction="row" spacing={1} sx={{ width: { xs: "100%", sm: "auto" } }}>
            <Button
              onClick={onClose}
              fullWidth={isMobile}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: 2,
                border: "1px solid",
                borderColor: alpha(theme.palette.divider, 0.8),
              }}
            >
              {t("ToDoList.Cancelar")}
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth={isMobile}
              sx={{
                ...pagePrimaryButtonSx(theme),
                color: theme.palette.primary.contrastText,
                whiteSpace: "nowrap",
              }}
            >
              {t("ToDoList.guardar")}
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "error.main" }}>
          {t("ToDoList.confirm")}
        </DialogTitle>
        <DialogContent>
          <Typography color="text.secondary">
            {t("ToDoList.confirmDelete")}
            <br />
            <strong>{tarea.tarea}</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button onClick={() => setOpenDeleteDialog(false)} sx={{ fontWeight: 700 }}>
            {t("ToDoList.Cancelar")}
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={deleting}
            onClick={async () => {
              try {
                setDeleting(true);
                await deleteTarea(tarea.id || tarea.Id);

                const token = localStorage.getItem("token");
                let deletedBy = "Another user";
                try {
                  const decoded = jwtDecode(token);
                  deletedBy =
                    decoded.username ||
                    decoded.name ||
                    decoded.email ||
                    "Unknown";
                } catch (e) {}

                socket.emit("tarea-eliminada", {
                  tareaId: tarea.id || tarea.Id,
                  deletedBy,
                });

                onUpdated({ ...tarea, _deleted: true });
                setOpenDeleteDialog(false);
                onClose();
              } catch (err) {
                console.error("Error deleting task:", err);
                alert("Error deleting task. Please try again.");
              } finally {
                setDeleting(false);
              }
            }}
            sx={{ fontWeight: 700 }}
          >
            {deleting ? "Deleting..." : t("ToDoList.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ToDoListGlobal;
